import { Pause, Play } from 'lucide-react';
import { FaInstagram, FaYoutube } from 'react-icons/fa';
import { playInBar } from '../../lib/spotifyPlayerPool';
import { useNowPlaying } from './NowPlayingBar';

/**
 * An event's artist as one Sets-style row (Sam's B, 2026-10-26, replacing Spotify's grey embed and the brand tiles):
 * the photo and name, Instagram and YouTube as quiet glass buttons, and play, which plays in the now-playing bar.
 * `players` is [{ spotifyId, name }]: two or more (co-headliners) play as tabs in the bar, like a b2b.
 */
export default function ArtistLinksRow({
  eventId,
  name,
  imageUrl,
  players = [],
  instagramUrl,
  youtubeUrl,
  playKey = null,
}) {
  const nowPlaying = useNowPlaying();
  const key = playKey ?? `event:${eventId}`;
  const isCurrent = nowPlaying.key === key;
  const isPlaying = isCurrent && !nowPlaying.paused;
  return (
    <div className="list-index__row artist-links-row">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="artist-links-row__thumb" />
      ) : (
        <span className="artist-links-row__thumb" aria-hidden />
      )}
      <span className="list-index__text">
        <span className="list-index__name">{name}</span>
      </span>
      {instagramUrl && (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="artist-links-row__link"
          aria-label="Instagram"
        >
          <FaInstagram size={16} aria-hidden />
        </a>
      )}
      {youtubeUrl && (
        <a
          href={youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="artist-links-row__link"
          aria-label="YouTube"
        >
          <FaYoutube size={17} aria-hidden />
        </a>
      )}
      {players.length > 0 && (
        <button
          type="button"
          className={`artist-row__play artist-links-row__play${isCurrent ? ' artist-row__play--current' : ''}`}
          onClick={() => playInBar(key, players, isCurrent ? nowPlaying.index : 0)}
          aria-label={isPlaying ? `Pause ${name}` : `Play ${name}`}
        >
          {isPlaying ? (
            <Pause size={15} fill="currentColor" strokeWidth={0} aria-hidden />
          ) : (
            <Play size={15} fill="currentColor" strokeWidth={0} className="ml-[2px]" aria-hidden />
          )}
        </button>
      )}
    </div>
  );
}
